export class GrecaptchaV2 {

    private errorElement !: JQuery;
    private elementId !: string;

    public setErrorContainer(containerElement : JQuery) : void {
        this.errorElement = containerElement;
    }

    /**
     * Visible "I'm not a robot" CAPTCHA
     * @param elementId - Target element ID
     */
    public init(elementId : string) : void {
        this.setElementId(elementId);
        if (typeof window.grecaptcha !== 'undefined') {
            let widgetId : number| null = null;
            window.grecaptcha.ready(() => {
                // If element not already rendered, then we rendered it
                try {
                    widgetId = window.grecaptcha.render(<HTMLElement>document.querySelector(`#${elementId}`), {
                        sitekey: $(`#${elementId}`).data('sitekey'),
                    });
                }
                catch (error) {
                    /* If the element is already rendered, then we try to get the widgetId,
                        which is simply the position of the element
                        with elementId in .g-recaptcha collection
                    */
                    widgetId = this.getWidget();
                    console.warn(error);
                }

                // It's possible the widgetId is still null, so we don't store it
                if (widgetId !== null) {
                    this.storeWidget(widgetId);
                }
            });
        }
    }

    /**
     * Removes the checkmark from the "I am not a robot" checkbox
     * and remove the error messages
     */
    public reset() : void {
        if (typeof window.grecaptcha !== 'undefined') {
            if (typeof this.errorElement !== 'undefined') {
                this.resetErrorContainer();
            }
            const widgetId = this.getWidget();
            if (widgetId !== null && typeof widgetId === 'number') {
                window.grecaptcha.reset(widgetId);
            }
            else {
                console.warn('widgetId is null');
            }
        }
    }

    private setElementId(elementId : string) : void {
        this.elementId = elementId;
    }

    private getElementId() : string {
        return this.elementId;
    }

    private resetErrorContainer() : void {
        if (typeof this.errorElement !== 'undefined') {
            this.errorElement.empty();
        }
    }

    /**
     * Store Google reCaptcha V2 widgets in elementId-widgetId pair
     * @param null|number widgetId
     */
    private storeWidget(widgetId : null | number) : void {
        if (typeof window.grecaptchaWidgets === 'undefined') {
            window.grecaptchaWidgets = {};
        }

        if (widgetId === null) {
            console.warn('Widget ID must be number, null given');
        }
        else {
            window.grecaptchaWidgets[this.getElementId()] = widgetId;
        }
    }

    /**
     * Get Google reCaptcha widget based on element ID selector
     * @return {number|null}
     */
    private getWidget() : null | number {
        if (typeof window.grecaptchaWidgets !== 'undefined'
            && typeof this.getElementId() !== 'undefined'
            && typeof window.grecaptchaWidgets[this.getElementId()] !== 'undefined') {
            return window.grecaptchaWidgets[this.getElementId()];
        }
        /**
         * if it's not stored, we try to find in DOM, and store it
         * @type {NodeListOf<Element>}
         */
        const recaptchaBoxes = document.querySelectorAll('.g-recaptcha');
        const targetElement = document.querySelector(`#${this.getElementId()}`);
        if (targetElement === null) {
            console.warn('targetElement not found');
            return null;
        }
        for (let index = 0, max = recaptchaBoxes.length; index < max; index++) {
            if (recaptchaBoxes[index].id === targetElement.id) {
                this.storeWidget(index);
                return index;
            }
        }

        console.warn('Google reCaptcha list or element not exists');
        return null;
    }

}
